import Vue from 'vue';
import Router from 'vue-router';
import Login from '@/views/Login.vue';
import ResetPasswd from '@/views/ResetPasswd.vue';
import Register from '@/views/Register/index.vue';
import RegisterTerms from '@/views/Register/Terms.vue';
import RegisterForm from '@/views/Register/Form.vue';
import RegisterReview from '@/views/Register/Review.vue';
import RegisterPayment from '@/views/Register/Payment.vue';
import Main from '@/views/index.vue';
import Dashboard from '@/views/Dashboard.vue';
import Management from '@/views/Management/index.vue';
import Bid from '@/views/Management/Bid.vue';
import Click from '@/views/Management/Click.vue';
import Order from '@/views/Management/Order.vue';
import Join from '@/views/Management/Join.vue';
import Bizmoney from '@/views/Bizmoney/index.vue';
import Paylist from '@/views/Bizmoney/Paylist.vue';
import Bonus from '@/views/Bizmoney/Bonus.vue';
import Payment from '@/views/Bizmoney/Payment.vue';
import Shop from '@/views/Shop/index.vue';
import Best from '@/views/Shop/Best.vue';
import Products from '@/views/Shop/Products.vue';
import User from '@/views/User/index.vue';
import Verify from '@/views/User/Verify.vue';
import Form from '@/views/User/Form.vue';
import Activity from '@/views/User/Activity.vue';
// import Products from '@/views/Management/Products.vue';
import PageNotFound from '@/views/PageNotFound.vue';

Vue.use(Router);

export default function (store, http) {
  const checkShopType = async function beforeEnter(to, from, next) {
    if (store.state.me.stab === 'temp') {
      return next('/register/review');
    }
    if (store.state.me.stab === 'store' && store.state.me.sstate !== 'A') {
      return next('/register/payment');
    }
    return next();
  };

  const checkSession = async function beforeEnter(to, from, next) {
    const [, pathName] = to.path.split('/');
    if (localStorage.token) {
      try {
        await store.dispatch('fetchMe');
        setInterval(async () => {
          if (localStorage.token) {
            await store.dispatch('fetchMe');
          }
        }, 1000 * 60 * 30);
        await store.dispatch('fetchCategories', { me: store.state.me });
        if (pathName !== 'register') await checkShopType(to, from, next);
        if (pathName === 'login') return next('/main');
      } catch (e) {
        localStorage.removeItem('token');
        http.defaults.headers.common['mk-sess'] = '';
        return next('/login');
      }
    } else if (pathName !== 'login' && to.path !== '/register/terms' && to.path !== '/register/form') {
      return next('/login');
    }

    return next();
  };

  const config = {
    linkActiveClass: 'active',
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
      {
        path: '/login',
        component: Login,
        // beforeEnter: checkSession,
      },
      {
        path: '/reset-passwd',
        component: ResetPasswd,
      },
      {
        path: '/payment',
        component: Payment,
        // beforeEnter: checkSession,
      },
      {
        path: '/register',
        component: Register,
        beforeEnter: checkSession,
        children: [
          { path: ':registerType(\\bterms\\b)', component: RegisterTerms },
          { path: ':registerType(\\bform\\b)', component: RegisterForm },
          { path: ':registerType(\\breview\\b)', component: RegisterReview },
          { path: ':registerType(\\bpayment\\b)', component: RegisterPayment },
        ],
      },
      {
        path: '/',
        component: Main,
        beforeEnter: checkSession,
        redirect: '/main',
        children: [
          { path: '/main', component: Dashboard },
          {
            path: 'shop',
            component: Shop,
            redirect: '/shop/best',
            children: [
              { path: 'best', component: Best },
              { path: 'products', component: Products },
            ],
          },
          {
            path: 'management',
            component: Management,
            redirect: '/management/bid',
            children: [
              { path: 'bid', component: Bid },
              { path: 'click', component: Click },
              { path: 'order', component: Order },
              { path: 'join', component: Join },
            ],
          },
          {
            path: 'bizmoney',
            component: Bizmoney,
            redirect: '/bizmoney/paylist',
            children: [
              { path: 'paylist', component: Paylist },
              { path: 'bonus', component: Bonus },
            ],
          },
          {
            path: 'user',
            component: User,
            redirect: '/user/verify',
            children: [
              { path: 'verify', component: Verify },
              { path: 'form', component: Form },
              { path: 'activity', component: Activity },
            ],
          },
        ],
      },
      { path: '*', component: PageNotFound },
    ],
  };

  return new Router(config);
}
